import React, {useContext} from 'react';
import './PrivacyPolicy.css';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';

import PrivacyPolicyDe from './de/PrivacyPolicyDe';
import PrivacyPolicyEn from './en/PrivacyPolicyEn';
import { useIndexUpdate } from '../common/hooks';

export function PrivacyPolicy(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div>
            <div className="bottom_padding side_padding flex_col margin_to_header">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <PrivacyPolicyEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>

            <Footer />
        </div>
    );
}
